import { Fab, Grid, Tooltip, makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import NewUserIcon from "../../../components/Icons/NewUserIcon";
import { ButtonsProps } from "../../../components/Table/types";
import {
  getBrandsAC,
  getBusinessUnitAC,
  getDeviceTypesAC,
} from "../../../store/action-creators/CommonListActionCreators";
import {
  setCurrentDevice,
  setIsDeviceEdit,
  setShowForm,
} from "../../../store/slices/DeviceSlice";

/**
 * Retorna los botones que se muestran junto a la tabla de datos
 * @param { boolean | undefined } justTable - Valida si está actualmente el formulario activado
 * @param { string } privilege - Array de string con los privilegios del usuario
 * @param { boolean | undefined } HideMassiveButon - validacion para esconder el botón masivo
 * @param { string } rol - rol del usuario
 * @returns { JSX.Element } botones y campo para filtrar información
 */
const GetButtons = (
  justTable: boolean | undefined,
  privilege: string[],
  HideMassiveButon?: boolean | undefined,
  rol?: string
) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const sizebuttons = rol === "BIOMETRIA RNEC" ? 7 : 4;

  let button: ButtonsProps = {
    searchBar: {
      cellSize: {
        lg: sizebuttons,
        md: sizebuttons,
        sm: 12,
        xs: 12,
      },
    },
    menuOrder: {
      justify: "center",
      options: [
        {
          label: "Activo",
          columns: [
            {
              prop: "state",
            },
          ],
        },
        {
          label: "Inactivo",
          columns: [
            {
              prop: "state",
              direction: -1,
            },
          ],
        },
        {
          label: "Más reciente",
          columns: [
            {
              prop: "createdOn",
              direction: 1,
              format: (date: any) => {
                return new Date(date).getTime();
              },
            },
          ],
        },
        {
          label: "Más antiguo",
          columns: [
            {
              prop: "createdOn",
              direction: -1,
              format: (date: any) => {
                return new Date(date).getTime();
              },
            },
          ],
        },
      ],
      cellSize: {
        xs: 12,
        sm: 12,
        md: 2,
        lg: 2,
      },
    },
    justify: "flex-start",
    exportButton: {
      cellSize: {
        xs: 12,
        sm: 12,
        md: 2,
        lg: 2,
      },
      fileName: "Listado de Dispositivos",
    },
    chargeButton: {},
    children: () => {
      return justTable ? (
        <></>
      ) : (
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={2}
          lg={2}
          direction="row-reverse"
          justifyContent="center"
        >
          <Tooltip title={`Crear dispositivo`} aria-label={`Nuevo dispositivo`}>
            <Fab
              className={classes.styleFab}
              size="small"
              onClick={() => {
                dispatch(setCurrentDevice());
                dispatch(setShowForm(true));
                dispatch(setIsDeviceEdit(true));
                dispatch(getBrandsAC());
                dispatch(getDeviceTypesAC());
                dispatch(getBusinessUnitAC());
              }}
              disabled={
                privilege.find(
                  (privil) => privil === "BIOMETRIA_DISPOSITIVO_CREATE"
                ) === undefined
                  ? true
                  : false
              }
            >
              <NewUserIcon />
            </Fab>
          </Tooltip>
        </Grid>
      );
    },
  };

  if (!HideMassiveButon) {
    button.chargeButton = {
      cellSize: {
        xs: 12,
        sm: 12,
        md: 2,
        lg: 2,
      },
    };
  }

  return button;
};

const useStyles = makeStyles(() => ({
  styleFab: {
    boxShadow: "none",
  },
}));

export default GetButtons;
